import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback.component';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { authGuard } from './core/guards/auth.guard';
import { homeGuard } from './core/guards/home.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { serviceGuard } from './core/guards/service.guard';
import { sessionTenantGuard } from './core/guards/session-tenant.guard';
import { AdlinkComponent } from './private/adlink/adlink.component';
import { adLinkResolver } from './private/adlink/resolvers/adlink.resolver';
import { DashboardComponent } from './private/dashboard/dashboard.component';
import { dashboardResolver } from './private/dashboard/resolvers/dashboard.resolver';
import { DiscountsComponent } from './private/discounts/discounts.component';
import { discountsResolver } from './private/discounts/resolvers/discounts.resolver';
import { EmailsComponent } from './private/emails/emails.component';
import { emailTemplateDataResolver } from './private/emails/resolvers/emails.resolver';
import { EventsComponent } from './private/events/events.component';
import { eventsResolver } from './private/events/resolvers/events.resolver';
import { GeneralSettingsComponent } from './private/general-settings/general-settings.component';
import { GroupLinksComponent } from './private/group-links/group-links.component';
import { groupLinksResolver } from './private/group-links/resolvers/group-links.resolver';
import { PrivateComponent } from './private/private.component';
import { RedisManagerComponent } from './private/redis-manager/redis-manager.component';
import { redisManagerResolver } from './private/redis-manager/resolvers/redis-manager.resolver';
import { ServiceChargesComponent } from './private/service-charges/service-charges.component';
import { ServiceChargesResolver } from './private/service-charges/resolvers/service-charges.resolver';
import { TransactionsComponent } from './private/transactions/transactions.component';
import {
  eventsPageLessResolver,
  transactionsResolver,
} from './private/transactions/resolvers/transactions.resolver';
import { UpgradeComponent } from './private/upgrade/upgrade.component';
import { upgradeResolver } from './private/upgrade/resolvers/upgrade.resolver';
import { UpsellComponent } from './private/upsell/upsell.component';
import { upsellResolver } from './private/upsell/resolvers/upsell.resolver';
import { UsersComponent } from './private/users/users.component';
import { usersResolver } from './private/users/resolvers/users.resolver';

export const routes: Routes = [
  {
    path: 'auth/callback',
    component: AuthCallbackComponent,
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: '403',
    component: ForbiddenComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [authGuard, homeGuard],
    children: [],
  },
  {
    path: 'transactions',
    pathMatch: 'full',
    redirectTo: 'private/transactions',
  },
  {
    path: 'private',
    component: PrivateComponent,
    canActivate: [authGuard, sessionTenantGuard, serviceGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'transactions',
      },
      {
        path: 'adlink',
        component: AdlinkComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { api: adLinkResolver },
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [permissionGuard],
        resolve: { api: dashboardResolver, events: eventsPageLessResolver },
      },
      {
        path: 'discounts',
        component: DiscountsComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { api: discountsResolver },
      },
      {
        path: 'general-settings',
        component: GeneralSettingsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: 'emails',
        component: EmailsComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { emailTemplate: emailTemplateDataResolver },
      },
      {
        path: 'events',
        component: EventsComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { api: eventsResolver },
      },
      {
        path: 'private-selling',
        component: GroupLinksComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { api: groupLinksResolver },
      },
      {
        path: 'redis-manager',
        component: RedisManagerComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { api: redisManagerResolver },
      },
      {
        path: 'service-charges',
        component: ServiceChargesComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { serviceCharges: ServiceChargesResolver },
      },
      {
        path: 'transactions',
        component: TransactionsComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { api: transactionsResolver, events: eventsPageLessResolver },
      },
      {
        path: 'upsell',
        component: UpsellComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { api: upsellResolver },
      },
      {
        path: 'upgrade',
        component: UpgradeComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { api: upgradeResolver },
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [permissionGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        resolve: { api: usersResolver },
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
